import styled from 'styled-components';
import FONTS from '../../constants/fonts.js';
import '../../constants/colors.js';
import FontSize from '../../constants/fontSize.js';
import '../../constants/theme.js';
import '../../constants/files.js';
import '../../constants/color-variant.js';
import '../../constants/zIndexList.js';

const StyledTextCTA = styled.button `
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    outline: inherit;

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }

    color: ${({ color }) => color};
    font-family: ${({ weight }) => weight && FONTS[weight.toUpperCase()]};
    display: inline-flex;
    align-items: center;
    gap: 2px;
    line-height: 1.5;
    font-size: ${({ size }) => (size ? `${FontSize[size]}rem` : "inherit")};
    text-decoration: ${({ underline }) => underline && "underline"};
    text-underline-offset: 2px;
`;

export { StyledTextCTA };
//# sourceMappingURL=TextCTA.styles.js.map
